<template>
  <div class="is-relative">
    <slot/>
    <qd-loading
      :active="active"
      :is-full-page="isFullPage"
      :can-cancel="canCancel"
      :on-cancel="onCancel"
      :animation="animation">
      <slot name="icon"/>
    </qd-loading>
  </div>
</template>

<script>
export default {
  name: 'qdLoader',
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    'is-full-page': {
      type: Boolean,
      required: false,
      default: false,
    },
    'can-cancel': {
      type: Boolean,
      required: false,
      default: false,
    },
    'on-cancel': {
      type: Function,
      required: false,
    },
    animation: {
      type: String,
      required: false,
      default: 'fade',
    },
  },
};
</script>
